const primaryButtonStyles = theme => ({
  '.btn-classic-primary': {
    backgroundColor: theme('colors.green1.75'),
    color: theme('colors.white'),
    border: 'none',
    'a&:hover, a&:focus': {
      color: theme('colors.white'),
    },
    '&:hover, &:focus': {
      backgroundColor: theme('colors.green1.55'),
    },

    '&:active': {
      backgroundColor: theme('colors.green1.60'),
    },

    '&.disabled': {
      backgroundColor: theme('colors.green1.30'),
    },
  },

  '.btn-classic-primary-emphasis': {
    backgroundColor: theme('colors.orange1.23'),
    color: theme('colors.black'),
    border: `1px solid ${theme('colors.orange1.30')}`,
    'a&:hover, a&:focus': {
      color: theme('colors.black'),
    },
    '&:hover, &:focus': {
      borderColor: theme('colors.orange1.30'),
      backgroundColor: theme('colors.orange1.25'),
    },

    '&:active': {
      borderColor: theme('colors.orange1.30'),
      backgroundColor: theme('colors.orange1.30'),
    },

    '&.disabled': {
      backgroundColor: theme('colors.orange1.15'),
      borderColor: theme('colors.orange1.15'),
      color: theme('colors.grey.40'),
      filter: 'none',
    },
  },

  '.btn-classic-primary-light': {
    backgroundColor: theme('colors.green1.10'),
    color: theme('colors.green1.55'),
    border: 'none',
    'a&:hover, a&:focus': {
      color: theme('colors.green1.55'),
    },
    '&:hover, &:focus': {
      backgroundColor: theme('colors.green1.15'),
    },

    '&:active': {
      backgroundColor: theme('colors.green1.20'),
    },

    '&.disabled': {
      backgroundColor: theme('colors.green1.40'),
      color: theme('colors.green1.20'),
    },
  },
});

module.exports = { primaryButtonStyles };
